import utils from "../../../utils/utils.js";

export default {
  async fetchEngagementInformationTemplateTopic(context, payload) {
    const pageNumber = payload.pageNumber;
    const pageSize = payload.pageSize;
    const sortColumn = payload.sortColumn;
    const sortDirection = payload.sortDirection;
    const searchText = payload.searchText;

    const responseData = await utils.utility.fetch(
      `api/Setting/GetInformationTemplateTopic?pageNumber=${pageNumber}&pageSize=${pageSize}&sortColumn=${sortColumn}&sortDirection=${sortDirection}&searchText=${searchText}`,
      "GET",
      null,
      null
    );
    context.commit("setEngagementInformationTemplateTopic", responseData.data);
  },

  async postEngagementInformationTemplateTopic(context, payload) {
    await utils.utility.fetch(
      `api/Setting/CreateEngagementInformationTemplateTopic`,
      "POST",
      null,
      payload
    );
  },
  async putEngagementInformationTemplateTopic(context, payload) {
    await utils.utility.fetch(
      `api/Setting/UpdateEngagementInformationTemplateTopic`,
      "PUT",
      null,
      payload
    );
  },

  async deleteEngagementInformationTemplateTopic(context, payload) {
    let postData = { id: payload.id };
    await utils.utility.fetch(
      `api/Setting/DeleteEngagementInformationTemplateTopic`,
      "POST",
      null,
      postData
    );
  },
};
